var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7292 21.849L13.8802 15C13.3594 15.4514 12.7521 15.803 12.0584 16.0547C11.3646 16.3064 10.6264 16.4323 9.84375 16.4323C7.96594 16.4323 6.37669 15.7813 5.07602 14.4792C3.77534 13.1771 3.125 11.6059 3.125 9.76563C3.125 7.92535 3.77604 6.35417 5.07812 5.05209C6.38021 3.75 7.95573 3.09896 9.80469 3.09896C11.6536 3.09896 13.2248 3.75 14.5182 5.05209C15.8116 6.35417 16.4583 7.92665 16.4583 9.76953C16.4583 10.5135 16.3368 11.2326 16.0938 11.9271C15.8507 12.6215 15.4861 13.2726 15 13.8802L21.875 20.7031L20.7292 21.849ZM9.81771 14.8698C11.2283 14.8698 12.4273 14.3707 13.4147 13.3724C14.4021 12.3741 14.8958 11.1719 14.8958 9.76563C14.8958 8.35938 14.4021 7.15712 13.4147 6.15886C12.4273 5.16059 11.2283 4.66146 9.81771 4.66146C8.39266 4.66146 7.18135 5.16059 6.1838 6.15886C5.18627 7.15712 4.6875 8.35938 4.6875 9.76563C4.6875 11.1719 5.18627 12.3741 6.1838 13.3724C7.18135 14.3707 8.39266 14.8698 9.81771 14.8698Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f9fd6c9865d8e0216596bbf53db24474.svg";
export { ForwardRef as ReactComponent };